import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";

import { useSearchDetailsStore } from "../../store/useSearchDetailsStore";
import { useAdditionalDetailsStore } from "../../store/useAdditionalDetailsStore";
import { FavoriteSelect } from "../../components/common/FavoriteSelect";

import { PhoneIcon } from "../../assets/image/PhoneIcon";
import { ServiceIcon } from "../../assets/image/ServiceIcon";
import { StarIcon } from "../../assets/image/StarIcon";
import { WhiteStarIcon } from "../../assets/image/WhiteStarIcon";
import { SocialFacebook } from "../../components/common/SocialFacebook";
import {DEFAULT_API} from "../../utils/variables";

export const SearchRightSection = ({
  sliderRef,
  providerData,
  handleSortedData,
  setShowCorrectList,
  showCorrectList,
  hireRateJob,
  setIsElement,
  toggleMoreContent,
  showInterested,
}) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const navigate = useNavigate();

  const [isOpenSelect, setIsOpenSelect] = useState(false);
  const [category, setCategory] = useState("Relevance");
  const [isOpenResult, setIsOpenResult] = useState(false);
  const [previosPage, setPreviousPage] = useState(10);

  const { profile } = useSearchDetailsStore();
  const { isResult } = useAdditionalDetailsStore();

  const generalSettings = {
    dots: false,
    infinite: true,
    slidesToShow: hireRateJob.length < 5 ? hireRateJob.length : 5,
    arrows: true,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
    ],
  };


  function getServiceTypesFromString(service_types) {
    const value = [];
    if (service_types.includes("tab1"))
      value.push(t("Nanny"));
    if (service_types.includes("tab2"))
      value.push(t("Special Education Teacher"));
    if (service_types.includes("tab3"))
      value.push(t("Special Education Paraprofessional"));
    if (service_types.includes("tab4"))
      value.push(t("Tutor"));
    return value.join(', ');
  }

  return (
    <div className="right_side_section">
      <div className="looking_for_candidate">
        <h2>
          {!localStorage.getItem("token") && !localStorage.getItem("id")
            ? t("theseFamilier")
            : t("These are job offers in your area")}
        </h2>
        <div className="looking_for_candidate_filter_sec">
          <div className="result">
            <p>
              {providerData.length}
              <span>
                {t("result")}
                {language === "en" && providerData.length > 1 ? "s" : ""}
              </span>
            </p>
          </div>
          <div className="page_filter">
            <div className="sortby">
              <label for="">{t("Sort by")}</label>
              <div className="sortby_select">
                {isOpenSelect ? (
                  <div
                    className="close_eve"
                    onClick={(e) => setIsOpenSelect(!isOpenSelect)}
                  ></div>
                ) : (
                  ""
                )}
                <div className="drodownsearch">
                  <span onClick={(e) => setIsOpenSelect(!isOpenSelect)}>
                    {t(category)}
                  </span>
                  {isOpenSelect ? (
                    <ul>
                      <li
                        onClick={(e) => {
                          handleSortedData("Relevance");
                          setCategory("Relevance");
                          setIsOpenSelect(!isOpenSelect);
                        }}
                      >
                        {t("Relevance")}
                      </li>
                      <li
                        onClick={(e) => {
                          handleSortedData("Reviews");
                          setCategory("Review");
                          setIsOpenSelect(!isOpenSelect);
                        }}
                      >
                        {t("Review")}
                      </li>
                      <li
                        onClick={(e) => {
                          handleSortedData("Distance");
                          setCategory("Distances.");
                          setIsOpenSelect(!isOpenSelect);
                        }}
                      >
                        {t("Distances.")}
                      </li>
                      <li
                        onClick={(e) => {
                          handleSortedData("Low to high");
                          setCategory("Rate: Low to high");
                          setIsOpenSelect(!isOpenSelect);
                        }}
                      >
                        {t("Rate: Low to high")}
                      </li>
                      <li
                        onClick={(e) => {
                          handleSortedData("High to low");
                          setCategory("Rate: High to low");
                          setIsOpenSelect(!isOpenSelect);
                        }}
                      >
                        
                        {t("Rate: High to low")}
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="resultperpage">
              <label for="">{t("result-page")}</label>
              <div className="resultperpage_select">
                {isOpenResult ? (
                  <div
                    className="close_eve"
                    onClick={(e) => setIsOpenResult(!isOpenResult)}
                  ></div>
                ) : (
                  ""
                )}
                <div className="drodownsearch">
                  <span onClick={(e) => setIsOpenResult(!isOpenResult)}>
                    {previosPage}
                  </span>
                  {isOpenResult ? (
                    <ul>
                      <li
                        onClick={(e) => {
                          setShowCorrectList(10);
                          setPreviousPage(10);
                          setIsOpenResult(!isOpenResult);
                        }}
                      >
                        10
                      </li>
                      <li
                        onClick={(e) => {
                          setShowCorrectList(15);
                          setPreviousPage(15);
                          setIsOpenResult(!isOpenResult);
                        }}
                      >
                        15
                      </li>
                      <li
                        onClick={(e) => {
                          setShowCorrectList(20);
                          setPreviousPage(20);
                          setIsOpenResult(!isOpenResult);
                        }}
                      >
                        20
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {providerData.map((data, index) => {
          if (index < showCorrectList) {
            return (
              <div className="looking_for_candidate_boxs">
                <div className="looking_for_candidate_box">
                  <div className="candidate_info">
                    <div className="profile_info">
                  <div className="first_sec">
                    <div className="image_sec">
                      <img
                        onClick={(e) => {
                          navigate("/profile-parents/" + data.id);
                        }}
                        src={
                          data.file_path != null
                            ? DEFAULT_API + '/assets/images/users/' +
                              data.file_path
                            : window.location.origin + "/img/nany_img.png"
                        }
                        alt=""
                      />
                      <div className="heart_sec">
                        {localStorage.getItem("user_type") != "parents" ? (
                          <FavoriteSelect
                            id={data.jobId}
                            heart2={data.favorNot}
                            username={data.first_name}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="nany_social">
                      {data.phoneVerifiedStatus == 1 ? (
                        <img
                          src={
                            window.location.origin + "/images/nany_phone.svg"
                          }
                          alt=""
                        />
                      ) : (
                        <PhoneIcon />
                      )}
                      <img
                        src={window.location.origin + "/images/nany_msg.svg"}
                        alt=""
                      />
                      {data.facebookverify != null ||
                      data.linkdinverify != null ? (
                        <img
                          src={window.location.origin + "/images/nany_cont.svg"}
                          alt=""
                        />
                      ) : (
                        <ServiceIcon />
                      )}
                    </div>
                  </div>
                  <div className="second_sec">
                    <div className="heading">
                      <h3
                        onClick={(e) => {
                          navigate("/profile-parents/" + data.id);
                        }}
                      >
                        {data.title != null ? data.title : ""}
                      </h3>

                    </div>
                    <div className="post_general">
                      <h6
                        onClick={(e) => {
                          navigate("/profile-parents/" + data.id);
                        }}
                      >
                        {data.first_name + " " + data.last_name} (
                        {data.dob != undefined
                          ? new Date().getFullYear() -
                            parseInt(
                              data.dob
                                .substr(data.dob.lastIndexOf("\\") + 1)
                                .split("-")[0]
                            )
                          : ""}
                        )
                      </h6>
                      <p>
                        {data.reviewAvg >= 0 ? (
                          <>
                            {[...Array(data.reviewAvg)].map((star, index) => {
                              index += 1;
                              return <StarIcon />;
                            })}
                            {[...Array(5 - data.reviewAvg)].map(
                              (star, index) => {
                                index += 1;
                                return <WhiteStarIcon />;
                              }
                            )}
                          </>
                        ) : (
                          ""
                        )}
                        <span> ({data.reviewcount})</span>
                      </p>
                    </div>
                    <div className="post_detail">
                      <div className="post">
                        {data.job_type != null ? (
                            data.job_type == "Nanny" || data.job_type == "Dadilja" ? (
                            <img
                              src={
                                window.location.origin + "/images/nany_post.svg"
                              }
                              alt=""
                            />
                          ) :  data.job_type == "Special Education Teacher" || data.job_type == "Defektolog" ? (
                            <img
                              src={
                                window.location.origin +
                                "/images/teacher_post.svg"
                              }
                              alt=""
                            />
                          ) : data.job_type == "Special Education Paraprofessional" || data.job_type == "Pedagoški asistent" ? (
                            <img
                              src={
                                window.location.origin +
                                "/images/education_post.svg"
                              }
                              alt=""
                            />
                          ) : data.job_type == "Tutor" ? (
                            <img
                              src={
                                window.location.origin +
                                "/images/tutor_post.svg"
                              }
                              alt=""
                            />
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                        <h5>
                          {data.job_type != null
                            ? t(data.job_type)
                            : ""}
                        </h5>
                      </div>
                      <div className="vi"></div>

                      <div className="post_pay">
                        <img
                          src={window.location.origin + "/img/post_pay.png"}
                          alt=""
                        />
                        {language === "sr" ? (
                          <h5>
                            {data.job_type == "Nanny" || data.job_type == "Dadilja"
                              ? data.nanyperhrrate != null
                                ? data.nanyperhrrate
                                    .substr(
                                      data.nanyperhrrate.lastIndexOf("\\") + 1
                                    )
                                    .split("-")[0] *
                                    100 +
                                  " - " +
                                  data.nanyperhrrate
                                    .substr(
                                      data.nanyperhrrate.lastIndexOf("\\") + 1
                                    )
                                    .split("-")[1] *
                                    100
                                : ""
                              : data.job_type == "Special Education Teacher" || data.job_type == "Defektolog"
                              ? data.seterhrrate != null
                                ? data.seterhrrate
                                    .substr(
                                      data.seterhrrate.lastIndexOf("\\") + 1
                                    )
                                    .split("-")[0] *
                                    100 +
                                  " - " +
                                  data.seterhrrate
                                    .substr(
                                      data.seterhrrate.lastIndexOf("\\") + 1
                                    )
                                    .split("-")[1] *
                                    100
                                : ""
                              : data.job_type == "Special Education Paraprofessional" || data.job_type == "Pedagoški asistent"
                              ? data.seperhrrate != null
                                ? data.seperhrrate
                                    .substr(
                                      data.seperhrrate.lastIndexOf("\\") + 1
                                    )
                                    .split("-")[0] *
                                    100 +
                                  " - " +
                                  data.seperhrrate
                                    .substr(
                                      data.seperhrrate.lastIndexOf("\\") + 1
                                    )
                                    .split("-")[1] *
                                    100
                                : ""
                              : data.job_type == "Tutor"
                              ? data.tutorperhrrate != null
                                ? data.tutorperhrrate
                                    .substr(
                                      data.tutorperhrrate.lastIndexOf("\\") + 1
                                    )
                                    .split("-")[0] *
                                    100 +
                                  " - " +
                                  data.tutorperhrrate
                                    .substr(
                                      data.tutorperhrrate.lastIndexOf("\\") + 1
                                    )
                                    .split("-")[1] *
                                    100
                                : ""
                              : ""}
                            {t("time-hour")}
                          </h5>
                        ) : (
                          <h5>
                            $
                            {data.job_type == "Nanny" || data.job_type == "Dadilja"
                              ? data.nanyperhrrate != null
                                ? data.nanyperhrrate
                                : ""
                              : data.job_type == "Special Education Teacher" || data.job_type == "Defektolog"
                              ? data.seterhrrate
                                ? data.seterhrrate
                                : ""
                              : data.job_type == "Special Education Paraprofessional" || data.job_type == "Pedagoški asistent"
                              ? data.seperhrrate
                                ? data.seperhrrate
                                : ""
                              : data.job_type == "Tutor"
                              ? data.tutorperhrrate
                                ? data.tutorperhrrate
                                : ""
                              : ""}
                            {t("time-hour")}
                          </h5>
                        )}
                      </div>
                      <div className="vi"></div>

                      <div className="post_fet">
                        <img
                          src={window.location.origin + "/images/post_fet.svg"}
                          alt=""
                        />
                        <h5>
                          {data.tutorintrestedin != null
                            ? t(data.tutorintrestedin)
                            : ""}
                        </h5>
                      </div>
                      <div className="vi"></div>
                      <div className="post_cal">
                        <img
                          src={window.location.origin + "/images/post_cal.svg"}
                          alt=""
                        />
                        <h5>
                          {data.tutorstartdate != null
                            ? data.tutorstartdate
                            : ""}
                        </h5>
                      </div>
                      <div className="vi"></div>
                      <div className="post_loc">
                        <img
                          src={window.location.origin + "/images/post_loc.svg"}
                          alt=""
                        />
                        <h5>
                          {data.country != null ? data.country : ""} ,
                          {data.city != null ? data.city : ""}
                        </h5>
                      </div>
                    </div>
                    <p id={"half" + index}>
                      {data.description != null
                        ? data.description.substr(0, 100)
                        : ""}
                      {data.description != null &&
                      data.description.length > 100 ? (
                        <span
                          onClick={(e) => {
                            setIsElement(true);
                            toggleMoreContent(
                              "half" + index,
                              "full" + index,
                              "plink" + index
                            );
                          }}
                        >
                          {t("text-more")}
                        </span>
                      ) : (
                        ""
                      )}
                    </p>

                    <p id={"full" + index} className="hide">
                      {data.description}
                      <span
                        onClick={(e) =>
                          toggleMoreContent(
                            "full" + index,
                            "half" + index,
                            "plink" + index
                          )
                        }
                      >
                        {t("text-less")}
                      </span>
                    </p>
                    </div>
                      </div>
<div className="job_bottom">
  <div></div>
                    <div className="view_profile_btn">
                      <button
                        onClick={(e) => {
                          navigate("/profile-parents/" + data.id);
                        }}
                      >
                        {t("view-profile")}
                      </button>
                    </div>
  </div>
                    </div>
                    <div className={"social_share_job"}>
                      {data.plateformonsocialmedia == "Yes" ? (
                          <SocialFacebook
                              link={
                                  window.location.origin +
                                  "/profile-parents/" +
                                  data.id
                              }
                          />
                      ) : (
                          ""
                      )}
                    </div>
                  </div>

                <p id={"plink" + index} className="hide">
                  {t("Please refer to our ")}
                  <Link to="/faq">{t("text-faq")}</Link> {t("text-and")}
                  <Link to="/safety-center">{t("safety-center")}</Link>
                  {t("read-safety-tips")}
                </p>
              </div>
            );
          }
        })}

        {providerData.length == 0 && isResult != "" ? (
          <div className="noresult">
            <h3>{t("no-result")}</h3>
            <img src={window.location.origin + "/images/search_noresult.svg"} />
          </div>
        ) : (
          ""
        )}
        {providerData.length >= 6 ? (
          <div className="load_more" onClick={(e) => setShowCorrectList(100)}>
            {t("text-load")}
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="mob_update_to_premium">
        <h2>
          <img
            src={window.location.origin + "/images/upgrade_icon.svg"}
            alt=""
          />
          <Link to={""}>{t("Upgrade to premium")}</Link>
          <span>
            <img
              src={window.location.origin + "/images/upgrade_right_side.svg"}
              alt=""
            />
          </span>
        </h2>
        <h3>
          {t("appear")}
          {localStorage.getItem("user_type") == "parents"
            ? " candidate"
            : " job today"}
        </h3>
      </div>
      <div className="update_to_premium">
        <h2>
          <img
            src={window.location.origin + "/images/upgrade_icon.svg"}
            alt=""
          />
          {t("appear")}
          {localStorage.getItem("user_type") == "parents"
            ? " candidate"
            : " job today"}
        </h2>
        <h3>
          <Link to={""}>{t("Upgrade to premium")}</Link>
          <span>
            <img
              src={window.location.origin + "/images/upgrade_right_side.svg"}
              alt=""
            />
          </span>
        </h3>
      </div>
      {showInterested === "" && (<div
        className={
          "interested_fam  " + (hireRateJob.length < 5 ? "main-header" : "")
        }
      >
        {
          hireRateJob && hireRateJob.length > 0 ?
              (<div
                  className={
                      "interested_fam  " + (hireRateJob.length < 5 ? "main-header" : "")
                  }
              >
                <h2>{t("See who families are interested in")}</h2>
                <p>{t("View popular candidates in your area")}</p>
                <div className="interested_fam_boxs">
                  <div className="interested_fam_boxs images_set">
                    {hireRateJob?.length < 5 ? (
                        hireRateJob?.map((data, index) => {
                          let data2 = data.user;
                          return (
                              <div
                                  className="interested_fam_box "
                                  style={{ marginBottom: "30px" }}
                              >
                                <div className="image_sec">
                                  <img
                                      src={
                                        data2.file_path != null
                                            ? DEFAULT_API +
                                            "/assets/images/users/" +
                                            data2.file_path
                                            : "img/nany_img.png"
                                      }
                                      alt=""
                                  />

                                </div>
                                <div className="general_sec">
                                  <h4>
                                    <Link
                                        to={
                                          data2.user_type == "parents"
                                              ? "/profile-parents/" + data2.id
                                              : "/profile-provider/" + data2.id
                                        }
                                        target="_blank"
                                    >
                                      {data2.first_name + " " + data2.last_name}
                                    </Link>
                                  </h4>
                                  {data.reviewAvg >= 0 ? (
                                      <>
                                        {[...Array(data.reviewAvg)]?.map((star, index) => {
                                          index += 1;
                                          return <StarIcon />;
                                        })}
                                        {[...Array(5 - data.reviewAvg)]?.map(
                                            (star, index) => {
                                              index += 1;
                                              return <WhiteStarIcon />;
                                            }
                                        )}
                                      </>
                                  ) : (
                                      ""
                                  )}
                                  <div className="detail_sec">
                                    <img
                                        src={window.location.origin + "/images/post_fet.svg"}
                                        alt=""
                                    />
                                    <p>

                                      {data.service_types != null
                                          ? getServiceTypesFromString(data.service_types)
                                          : ""}
                                    </p>
                                  </div>
                                  <div className="detail_sec">
                                    <img
                                        src={window.location.origin + "/images/post_pay.svg"}
                                        alt=""
                                    />
                                    <p>
                                      ${data2.nanyperhrrate} {t("time-hour")}
                                    </p>
                                  </div>
                                  <div className="detail_sec">
                                    <img
                                        src={window.location.origin + "/images/post_rang.svg"}
                                        alt=""
                                    />
                                    <p>
                                      {data2.nanyyearexp != null
                                          ? data2.nanyperhrrate
                                          : data2.setyearexp != null
                                              ? data2.setyearexp
                                              : data2.tutorexp != null
                                                  ? data2.tutorexp
                                                  : data2.yearofexpasteacher != null
                                                      ? data2.yearofexpasteacher
                                                      : "0"}
                                      {t("years-experience")}
                                    </p>
                                  </div>
                                  <div className="detail_sec">
                                    <img
                                        src={window.location.origin + "/images/post_loc.svg"}
                                        alt=""
                                    />
                                    <p>{data2.city + ", " + data2.country}</p>
                                  </div>
                                </div>
                              </div>
                          );
                        })
                    ) : (
                        <Slider
                            ref={sliderRef}
                            {...generalSettings}
                            id="Slider-4"
                            className="slider_test"
                        >
                          {hireRateJob && hireRateJob.map((data, index) => {
                            let data2 = data;
                            if (data.status == 0) {
                              return (
                                  <div className="item" key={index}>
                                    <div className="interested_fam_box ">
                                      <div className="image_sec">
                                        <img
                                            src={
                                              data2.file_path != null
                                                  ? DEFAULT_API +
                                                  "/assets/images/users/" +
                                                  data2.file_path
                                                  : "img/nany_img.png"
                                            }
                                            alt=""
                                        />

                                      </div>
                                      <div className="general_sec">
                                        <h4>
                                          <Link
                                              to={
                                                data2.user_type == "parents"
                                                    ? "/profile-parents/" + data2.id
                                                    : "/profile-provider/" + data2.id
                                              }
                                              target="_blank"
                                          >
                                            {data2.first_name + " " + data2.last_name}
                                          </Link>
                                        </h4>
                                        {data.reviewAvg >= 0 ? (
                                            <>
                                              {[...Array(data.reviewAvg)]?.map(
                                                  (star, index) => {
                                                    index += 1;
                                                    return <StarIcon />;
                                                  }
                                              )}
                                              {[...Array(5 - data.reviewAvg)]?.map(
                                                  (star, index) => {
                                                    index += 1;
                                                    return <WhiteStarIcon />;
                                                  }
                                              )}
                                            </>
                                        ) : (
                                            ""
                                        )}
                                        <div className="detail_sec">
                                          <img
                                              src={
                                                  window.location.origin +
                                                  "/images/post_fet.svg"
                                              }
                                              alt=""
                                          />
                                          <p>

                                            {data.service_types != null
                                                ? getServiceTypesFromString(data.service_types)
                                                : ""}
                                          </p>
                                        </div>
                                        <div className="detail_sec">
                                          <img
                                              src={
                                                  window.location.origin +
                                                  "/images/post_pay.svg"
                                              }
                                              alt=""
                                          />
                                          <p>
                                            ${data2.nanyperhrrate} {t("time-hour")}
                                          </p>
                                        </div>
                                        <div className="detail_sec">
                                          <img
                                              src={
                                                  window.location.origin +
                                                  "/images/post_rang.svg"
                                              }
                                              alt=""
                                          />
                                          <p>
                                            {data2.nanyyearexp != null
                                                ? data2.nanyperhrrate
                                                : data2.setyearexp != null
                                                    ? data2.setyearexp
                                                    : data2.tutorexp != null
                                                        ? data2.tutorexp
                                                        : data2.yearofexpasteacher != null
                                                            ? data2.yearofexpasteacher
                                                            : "0"}
                                            years-experience
                                          </p>
                                        </div>
                                        <div className="detail_sec">
                                          <img
                                              src={
                                                  window.location.origin +
                                                  "/images/post_loc.svg"
                                              }
                                              alt=""
                                          />
                                          <p>{data2.city + ", " + data2.country}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              );
                            }
                          })}
                        </Slider>
                    )}
                  </div>
                  <br />
                  <br />
                  <br />
                </div>
              </div>) : (
                  <div style={{
                    marginBottom: "30px"
                  }}>
                  </div>
              )
        }
        <br />
        <br />
        <br />
      </div> )}
    </div>
  );
};
